<template>
  <div id="app-content" class="flex w-full justify-content-center">
    <div class="flex justify-content-center my-2">
      <router-view />
    </div>
  </div>
  <Toast>
    <template #message="slotProps">
      <span class="p-icon p-toast-message-icon"><i :class="'pi ' + fc_getIconSeverity(slotProps.message.severity) + ' text-4xl'"></i></span>
      <div class="p-toast-message-text">
        <span class="p-toast-summary" v-html="slotProps.message.summary"></span>
        <div class="p-toast-detail" v-html="slotProps.message.detail" />
      </div>
    </template>
  </Toast>
</template>

<script>
import { usePrimeVue } from 'primevue/config';
import txt_app from '@/common/json/txt_app.json';
import txt_primevue from '@/common/json/txt_primevue.json';
export default {
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {},
  watch: {},
  methods: {},
  created() {
    this.$store.state.lang = this.fc_getLang();
    const primevue = usePrimeVue();

    if (this.$store.state.lang == 'pt') {
      this.$store.state.txt_app = txt_app.pt;
      this.$store.state.txt_primevue = txt_primevue.pt;
      primevue.config.locale = txt_primevue.pt;
    } else if (this.$store.state.lang == 'en') {
      this.$store.state.txt_app = txt_app.en;
      this.$store.state.txt_primevue = txt_primevue.en;
      primevue.config.locale = txt_primevue.en;
    } else if (this.$store.state.lang == 'fr') {
      this.$store.state.txt_app = txt_app.fr;
      this.$store.state.txt_primevue = txt_primevue.fr;
      primevue.config.locale = txt_primevue.fr;
    } else if (this.$store.state.lang == 'es') {
      this.$store.state.txt_app = txt_app.es;
      this.$store.state.txt_primevue = txt_primevue.es;
      primevue.config.locale = txt_primevue.es;
    }

    this.$router.beforeEach((to, from, next) => {
      this.$store.state.prevRoute = from;
      next();
    });
  },
  mounted() {},
  unmounted() {},
};
</script>

<style>
@import '@/common/css/vars.css';
@import '@/common/css/layout.css';
@import '@/common/css/elements.css';
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
